<script lang='ts'>
  import type { SellSheet } from '@shared/types/SellSheet';
  import CopyClipBoard from './CopyClipBoard.svelte';

  export let show:boolean;
  export let sellSheet:SellSheet;
  export let closeOnBackgroundClick:boolean = true;
  export let overflow:string = '';
  export let responsiveLayout: boolean = false;

  let copied = false;

  function closeModal() {
    document.body.style.overflow = "";
    show = false;
  };

  function closeClick() {
    if (closeOnBackgroundClick) { closeModal() }
  }

  function closeKey(event) {
    if (closeOnBackgroundClick && event.which == 27) {
      closeModal()
    }
  }

  let customOverflow = '';
  if (overflow) {
    customOverflow = `overflow: ${overflow};`;
  }

  const copy = () => {
    const app = new CopyClipBoard({
      target: document.getElementById('clipboard'),
      props: { text: "https://app.provi.com/sellsheet/" + sellSheet.id },
    });
    app.$destroy();
    copied = true;
    setTimeout(function(){
      copied = false;
    }, 5000);
  }

</script>

<style lang='scss'>
  .copied-success-message {
    margin-top: 30px;
    margin-bottom: -75px;

    @media (max-width: 700px) {
      margin-bottom: 15px;
    }
  }
</style>

<svelte:window on:keydown={closeKey}></svelte:window>

{#if show}
  <div class='fizz-modal fizz-modal-large fizz-is-open svelte-1dmwj0t' id='fizzModalCustom' style="overflow: auto;" on:click|stopPropagation>
    <div class="fizz-modal-overlay fizz-modal-toggle"
      data-modal="fizzModal" on:click={closeClick}></div>

    {#if copied}
      <div class="fizz-modal-content fizz-alert-success copied-success-message">
        <p>Link copied to clipboard</p>
      </div>
    {/if}

    <div class='fizz-modal-content'>
      <slot></slot>
    </div>

    <div class='fizz-modal-content' style='margin-top: 16px;'>
      <header class='fizz-space-between fizz-inset-square-24' class:fizz-space-between={!responsiveLayout}>
          <p><strong>Link</strong> <span class="fizz-text-subdued">Accessible only with direct link</span></p>
          <div class="fizz-flex-row">
            <p>{"https://app.provi.com/sellsheet/" + sellSheet.id}</p>
            <div class='close-share-sellsheet-modal' on:click={copy}>
              <div class="cursor-pointer margin-right--smallest color-yellow">
                <button class="fizz-icon-button-small">
                  <svg width="14" height="17" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 0H2C0.9 0 0 0.9 0 2V16H2V2H14V0ZM17 4H6C4.9 4 4 4.9 4 6V20C4 21.1 4.9 22 6 22H17C18.1 22 19 21.1 19 20V6C19 4.9 18.1 4 17 4ZM17 20H6V6H17V20Z" fill="#002B48"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
      </header>
      <div id="clipboard"></div>
    </div>
  </div>
{/if}
